import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="autocomplete"
export default class extends Controller {
  static targets = ["select"]
  static values = { url: String, value: String, label: String, search: String, noResults: String }

  connect() {
    console.log(this.selectTarget, this.valueValue, this.labelValue, this.searchValue, this.urlValue)
    new TomSelect(this.selectTarget, {
      valueField: this.valueValue,
      labelField: this.labelValue,
      searchField: this.searchValue.split(" "),
      maxOptions: 5,
      load: async (query, callback) => {
        if (!query.length) return callback()
        const response = await fetch(`${this.urlValue}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
          },
          body: JSON.stringify({ query }),
        })
        const data = await response.json()
        console.log(data)
        callback(data)
      },
      render: {
        no_results: (data, escape) => {
          return `<div class="no-results">${this.noResultsValue}</div>`;
        }
      }
    })
  }
}
